import axios from 'axios'
import * as CONFIG from '../config/index'
import moment from 'moment'

export const STATISTIC_API_URL = `${CONFIG.API_URL}/statistic`
export const VIEW_IP_API_URL = `${STATISTIC_API_URL}/view-ip`
export const SEARCH_API_URL = `${STATISTIC_API_URL}/search`

export const viewIpContent = async (ipContentId) => {
  await axios.get(`${VIEW_IP_API_URL}/${ipContentId}`)
}

const getISODateString = date => {
  return (date && date.toISOString()) || ''
}

export const searchStatistic = async ({contentId, account, action, startDate, endDate, page, size}) => {
  return (await axios.get(`${SEARCH_API_URL}` +
    `?contentId=${contentId}&account=${account}&action=${action}` +
    `&startDate=${getISODateString(startDate)}&endDate=${getISODateString(endDate)}&page=${page}&size=${size}&sort=time,desc`)).data
}



// WEBPACK FOOTER //
// ./src/common/statistic.js